export const FetchType = {
  INSTANT: 'instant',
  LAZY: 'lazy',
};
